import { Theme, styled } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import { Button } from "@mui/material";

export const ButtonStyled = styled(Button)({
  color: '#616161', border: '1px solid #B0B0B0',
  '&:hover':{ border: '1px solid #B0B0B0' },
  height: '2.3rem'
});

export const useStyles = makeStyles((theme: Theme) => ({ 
  gridFilters:{
    display: 'flex',
    gap: '1rem'
  },
  gridButtons:{
    height: '2.25rem',
    display: 'flex',
    flexDirection: 'row', 
    gap: '1.5rem'
  },
  buttomContacts:{
    "&.MuiButton-root":{
      maxWidth: "300px", 
      backgroundColor: '#FFF', 
      color: '#616161',
      '&:hover':{
        backgroundColor: '#FFF'
      }
    }
  },
  gridContactsInfo: {
    height: '8.875rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paperContactsInfo:{
    '&.MuiPaper-root':{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      boxShadow: 'none',
      border: "1px solid #CFCFCF",
      borderRadius: '0.5rem',
      padding: '0.5rem',
      gap: '0.5rem',
      width: '28rem'
    }
  },
  typographyBigNumber:{
    '&.MuiTypography-root':{
      color: '#0C20B5',
      fontWeight: 700,
      fontSize: '2rem',
      letterSpacing: '0.05rem',
      lineHeight: '2.375rem'
    }
  },
  typographyTitle:{
    '&.MuiTypography-root':{
      fontWeight: 500,
      fontSize: '1rem',
      lineHeight: '1.625rem',
      color: '#1E1F21'
    }
  },
  typographySubTitle:{
    '&.MuiTypography-root':{
      fontWeight: 500,
      fontSize: '0.875rem',
      lineHeight: '1.375rem',
      color: '#616161'
    }
  },
  typographyCellTable:{
    '&.MuiTypography-root':{
      margin: '0px',
      fontStyle: 'normal',
      fontWeight: 500,
      fontSize: '0.875rem',
      lineHeight: '0.8rem',
      color: '#616161'
    }
  }
}));